module.exports = __webpack_public_path__ + "static/media/france.e150bd00.svg";